export default __webpack_public_path__ + "static/media/videos.3c39b1ea.png";